export default class Video {
  id: number
  title: string
  description: string
  url: string
  status: number

  constructor(values: VideoConstructorValues) {
    this.id = values.id
    this.title = values.title
    this.description = values.description
    this.url = values.url
    this.status = values.status
  }
}

export interface VideoConstructorValues {
  id: number
  title: string
  description: string
  url: string
  status: number
}

